var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sms-btn"},[(_vm.shape)?_c('Button',{style:({ height: _vm.height }),attrs:{"type":"primary","shape":_vm.shape},on:{"click":_vm.getCodeEvent}},[_vm._v(_vm._s(_vm.text))]):_c('Button',{style:({ height: _vm.height }),attrs:{"type":"primary"},on:{"click":_vm.getCodeEvent}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }